import type { StepperStep } from '../components/design-system';

/** The traveler funnel, in flow order: travelers browse their matches for free,
 *  choose a host, then pay to request the trip. */
export const JOURNEY_STEPS: StepperStep[] = [
  { label: 'Chat with Alma', sub: 'Tell her how you travel' },
  { label: 'Choose your host', sub: 'Pick who curates your trip' },
  { label: 'Payment', sub: 'One flat fee for your curated trip' },
  { label: 'Trip ready', sub: 'Your handbook and host chat open up' },
];
